import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, InputNumber, InputNumberProps } from "antd";
import styled from "styled-components";

export const IncreaseDecreaseNumberInput = ({
  ...inputNumberProps
}: InputNumberProps) => {
  const { value, onChange } = inputNumberProps;
  const handleDecrease = () => {
    if (typeof value === "number") {
      onChange?.(value - 1);
    }
  };
  const handleIncrease = () => {
    if (typeof value === "number") {
      onChange?.(value + 1);
    }
  };
  return (
    <StyledInputNumber
      size="middle"
      defaultValue={0}
      min={0}
      max={100}
      step={1}
      changeOnWheel
      addonBefore={
        <Button
          data-testid="decrease-button"
          icon={<MinusOutlined style={{ fontSize: 10 }} />}
          size="small"
          type="text"
          onClick={handleDecrease}
        />
      }
      addonAfter={
        <Button
          data-testid="increase-button"
          icon={<PlusOutlined style={{ fontSize: 10 }} />}
          size="small"
          type="text"
          onClick={handleIncrease}
        />
      }
      controls={false}
      {...inputNumberProps}
    />
  );
};
const StyledInputNumber = styled(InputNumber)`
  width: 80px; /* to not truncate the input */
  .ant-input-number {
    border-right: none;
    border-left: none;
    box-shadow: none;
    input {
      padding: 4px;
      text-align: center;
      font-weight: 500;
    }
  }

  .ant-input-number-focused,
  .ant-input-number:hover {
    border-top-color: ${({ theme }) => theme.colorBorder};
    border-bottom-color: ${({ theme }) => theme.colorBorder};
  }
  .ant-input-number-group-addon {
    padding: 0 2px;
  }
`;
